import { FixedPageHeader } from 'Components/Layout';
import { useSelector } from 'react-redux';

const FixedEquipmentHeader: React.FC = () => {
  const type = useSelector((state) => (state.equipment.equipmentType as any)?.EquipmentType);
  const syncing = useSelector((state) => state.equipment.status.synchronising);
  const dirty = useSelector((state) => state.equipment.status.dirty);

  return (
    <FixedPageHeader
      pageIdentifier={type}
      pageStatus={syncing ? 'Saving...' : 'Saved'}
      pageProcessing={syncing || dirty}
    />
  );
};

export default FixedEquipmentHeader;
